import { Cpu, Database, Workflow, ShieldCheck } from "lucide-react";
import { TECH_PILLARS, IMG } from "@/data/site";
import { Seo, Reveal, Overline, GlassCard, SectionHeader } from "@/components/site/primitives";
import { ArchitectureDiagram } from "@/components/site/ArchitectureDiagram";

const ICONS = [Cpu, Database, Workflow, ShieldCheck];

export default function Technology() {
  return (
    <div className="pt-36 pb-32">
      <Seo title="Technology — ORAYA" description="Intelligence that connects every part of the business. AI-first, unified data, smart workflows, enterprise grade." path="/technology" />
      <div className="oraya-container">
        <Reveal>
          <SectionHeader overline="Technology" title="Intelligence that connects every part of the business." subtitle="ORAYA is built on four foundations — orchestrated by the Intelligence Core into one continuous system." />
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {TECH_PILLARS.map((t, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={t.tag} delay={i * 0.08}>
                <GlassCard variant="medium" hover className="p-8 h-full" data-testid={`technology-pillar-${i}`}>
                  <Icon className="w-6 h-6 text-ink" strokeWidth={1.4} />
                  <h3 className="text-sm font-semibold tracking-[0.18em] text-ink mt-8">{t.tag}</h3>
                  <p className="text-sm text-subtle mt-3 leading-relaxed">{t.text}</p>
                </GlassCard>
              </Reveal>
            );
          })}
        </div>
      </div>

      <section className="oraya-container py-28 md:py-36">
        <Reveal>
          <SectionHeader align="center" overline="ORAYA Intelligence Architecture" title="One core. Every layer connected." subtitle="Hover any layer to understand its role. Data flows into intelligence, intelligence into decisions, decisions into action — and outcomes back into learning." />
        </Reveal>
        <Reveal delay={0.1}><ArchitectureDiagram /></Reveal>
      </section>

      <section className="oraya-container">
        <Reveal>
          <div className="relative rounded-3xl overflow-hidden min-h-[300px] md:min-h-[420px] glass-heavy">
            <img src={IMG.dataTexture} alt="Abstract unified data foundation texture" className="absolute inset-0 w-full h-full object-cover opacity-70" loading="lazy" />
            <div className="absolute inset-0 bg-gradient-to-t from-surface via-surface/50 to-transparent" />
            <div className="absolute bottom-0 left-0 p-10 md:p-14 max-w-xl">
              <h3 className="display text-3xl md:text-4xl font-light text-ink">A connected data foundation.</h3>
              <p className="text-subtle mt-4">Unified, secure and scalable — the substrate that lets ORAYA understand an entire business.</p>
            </div>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
